// Quick-create de contato vinculado a empresa selecionada.
// Extraído de ComercialPipeline.tsx em 2026-05-23 (frontend wave 3B).
import { useState } from 'react';
import axios from 'axios';
import {
  Input, Select, Modal, Form, Row, Col, Checkbox, App as AntApp,
} from 'antd';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import { Cliente } from './types';

export function FormCriarContato({ termo, clienteIdInicial, clientes, onClose, onCriado }: {
  termo: string; clienteIdInicial: string; clientes: Cliente[];
  onClose: () => void; onCriado: (contato: any) => void;
}) {
  const { message } = AntApp.useApp();
  const [form, setForm] = useState({
    nome: termo, email: '', telefone: '', cargo: '', decisor: false,
    cliente_id: clienteIdInicial,
  });
  const [salvando, setSalvando] = useState(false);

  async function salvar() {
    if (!form.nome.trim()) { message.warning('Nome obrigatório'); return; }
    if (!form.cliente_id) { message.warning('Selecione a empresa'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      const res = await axios.post(`${API_URL}/comercial/contatos`,
        { ...form, cliente_id: parseInt(form.cliente_id) },
        { headers: { Authorization: token } });
      const data = res.data.body ? JSON.parse(res.data.body) : res.data;
      message.success('Contato criado.');
      onCriado(data);
    } catch (e: any) {
      message.error('Erro: ' + (e.response?.data?.error || e.response?.data?.erro || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <Modal open onCancel={onClose} onOk={salvar} confirmLoading={salvando}
      title="Novo contato (rápido)" okText="Criar e usar" cancelText="Cancelar" width={480} destroyOnClose>
      <Form layout="vertical" size="small">
        <Form.Item label="Empresa" required>
          <Select value={form.cliente_id || undefined} onChange={(v) => setForm({ ...form, cliente_id: v || '' })}
            placeholder="Selecione a empresa" showSearch optionFilterProp="label"
            options={clientes.map(c => ({ label: c.razao_social, value: String(c.id) }))} />
        </Form.Item>
        <Form.Item label="Nome" required>
          <Input value={form.nome} autoFocus onChange={e => setForm({ ...form, nome: e.target.value })} />
        </Form.Item>
        <Row gutter={10}>
          <Col span={12}>
            <Form.Item label="E-mail">
              <Input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Telefone">
              <Input value={form.telefone} onChange={e => setForm({ ...form, telefone: e.target.value })} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Cargo">
          <Input value={form.cargo} onChange={e => setForm({ ...form, cargo: e.target.value })}
            placeholder="Ex.: Gerente de Engenharia" />
        </Form.Item>
        <Checkbox checked={form.decisor} onChange={e => setForm({ ...form, decisor: e.target.checked })}>
          ★ É decisor
        </Checkbox>
      </Form>
    </Modal>
  );
}
